module.exports = __webpack_public_path__ + "img/on-the-edge_tn.1f888c9c.jpg";